document.addEventListener('DOMContentLoaded', function () {
  // 0. 初始化首屏数据和分页地址
  window.dealerStores = [];
  let nextFetchUrl = null;
  const initialScript = document.getElementById('dealer-data-chunk');
  if (initialScript) {
    const initialData = JSON.parse(initialScript.textContent);
    window.dealerStores = initialData.data;
    nextFetchUrl = initialData.nextUrl;
  }

  // 动态获取当前 Section ID，启用 Shopify Section Rendering API
  // 缩减JSON 数据的请求
  const currentSection = document.querySelector('.x-dealer-locator').closest('.shopify-section');
  const sectionId = currentSection ? currentSection.id.replace('shopify-section-', '') : null;

  // 在地图初始化前，立即开启异步抓取
  // 使用 Promise 包装，稍后将与 Mapbox 的加载并行执行
  const fetchAllDataPromise = (async () => {
    xUtils.showLoading();
    try {
      while (nextFetchUrl) {
        // 动态拼接 section_id 参数
        const fetchUrl = sectionId
          ? `${nextFetchUrl}${nextFetchUrl.includes('?') ? '&' : '?'}section_id=${sectionId}`
          : nextFetchUrl;

        const response = await fetch(fetchUrl);
        const htmlText = await response.text();
        const doc = new DOMParser().parseFromString(htmlText, 'text/html');
        const scriptTag = doc.getElementById('dealer-data-chunk');

        if (scriptTag) {
          const chunkData = JSON.parse(scriptTag.textContent);
          window.dealerStores = window.dealerStores.concat(chunkData.data);
          nextFetchUrl = chunkData.nextUrl;
        } else {
          nextFetchUrl = null;
        }
      }
    } catch (error) {
      console.error('Failed to fetch remaining dealers:', error);
    } finally {
      xUtils.hideLoading();
    }
  })();

  // 1. 数据转换辅助函数 (用于 Mapbox WebGL 渲染)
  function convertToGeoJSON(stores) {
    return {
      type: 'FeatureCollection',
      features: stores.map((store) => ({
        type: 'Feature',
        properties: {
          id: store.id,
          name: store.name,
          address: store.address,
          phone: store.phone,
          website: store.website,
        },
        geometry: {
          type: 'Point',
          coordinates: [store.lng, store.lat],
        },
      })),
    };
  }

  // 3. init Mapbox
  mapboxgl.accessToken =
    'pk.eyJ1IjoidmluY2VudC14ZHMiLCJhIjoiY21uMm5waG9zMWF2NzJyc2Y5bmw4ZnF1aiJ9.IsF3sD7h3asGqC67Y0Id4g';
  const map = new mapboxgl.Map({
    container: 'map-container',
    style: 'mapbox://styles/vincent-xds/cmn2tf4vb000201qwg0aw0bbr',
    center:
      window.dealerStores.length > 0
        ? [window.dealerStores[0].lng, window.dealerStores[0].lat]
        : [-95, 38],
    zoom: 10,
  });
  map.addControl(new mapboxgl.NavigationControl(), 'top-right');

  // calculate distance
  function calculateDistance(lat1, lon1, lat2, lon2) {
    const R = 3958.8; // earth radius mi
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  // UI Detail rendering
  function showStoreDetail(store) {
    // 1. set detail content
    document.getElementById('detail-name').innerText = store.name;
    document.getElementById('detail-address').innerText = store.address;
    document.getElementById('detail-phone').innerText = store.phone || 'N/A';

    const webLink = document.getElementById('detail-website');
    if (store.website) {
      webLink.href = store.website;
      webLink.innerText = store.website;
      webLink.parentElement.style.display = 'block';
    } else {
      webLink.innerText = 'N/A';
      webLink.parentElement.style.display = 'none';
    }

    // 2. set Google Maps navigation link
    const destination = encodeURIComponent(`${store.name}, ${store.address}`);
    const gMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
    document.getElementById('google-maps-link').href = gMapsUrl;

    // 3. activate animation
    document.getElementById('sidebar-slider').classList.add('show-detail');

    // 4. map fly to the store loc
    map.flyTo({ center: [store.lng, store.lat], zoom: 15, duration: 2000 });
  }

  // back to list view
  function hideStoreDetail() {
    document.getElementById('sidebar-slider').classList.remove('show-detail');
    // display whole map
    map.flyTo({ zoom: 10, duration: 1500 });
  }

  document.getElementById('back-to-list').addEventListener('click', hideStoreDetail);

  function generateStoreItemHtml(storeItem) {
    if (!storeItem) return '';
    const item = document.createElement('div');
    const storeItemHtml = [
      `
        <h3>${storeItem.name}</h3>
        <p class="dealer-info-address">${storeItem.address}</p>
      `,
    ];
    item.className = 'store-item';

    if (storeItem.dist) {
      // storeItemHtml.push(`<span class="distance-tag">${storeItem.dist.toFixed(1)} km away</span>`);
      storeItemHtml.push(`<span class="distance-tag">${storeItem.dist.toFixed(1)} mi away</span>`);
    }

    item.innerHTML = storeItemHtml.join('');
    item.onclick = () => showStoreDetail(storeItem);
    return item;
  }
  // ==========================================

  // 全局 Popup 实例 (复用你原本的 Popup HTML 结构)
  const popup = new mapboxgl.Popup({
    offset: [0, -60],
    closeButton: false,
    focusAfterOpen: false,
  });

  let userMarker = null; // store user marker

  function renderList(userCoords = null) {
    const listEl = document.getElementById('listings');
    listEl.innerHTML = '';

    if (userCoords) {
      window.dealerStores.forEach(
        (s) => (s.dist = calculateDistance(userCoords.lat, userCoords.lng, s.lat, s.lng))
      );
      window.dealerStores.sort((a, b) => a.dist - b.dist);
    }

    // 直接渲染所有门店信息到列表
    window.dealerStores.forEach((store) => {
      const item = generateStoreItemHtml(store);
      listEl.appendChild(item);
    });
  }

  function renderFilteredList(filteredData) {
    const listEl = document.getElementById('listings');
    listEl.innerHTML = '';

    if (filteredData.length === 0) {
      listEl.innerHTML =
        '<div class="store-item">No local stores found. Press Search for global search.</div>';
      return;
    }

    // 搜索结果也全量渲染
    filteredData.forEach((store) => {
      const item = generateStoreItemHtml(store);
      listEl.appendChild(item);
    });
  }

  function executeLocation(isAutoLoad = false) {
    if (!navigator.geolocation) {
      if (!isAutoLoad) alert('Please enable location services.');
      if (isAutoLoad) renderList();
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const userCoords = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        map.flyTo({ center: [userCoords.lng, userCoords.lat], zoom: 12 });

        if (userMarker) {
          userMarker.setLngLat([userCoords.lng, userCoords.lat]);
        } else {
          userMarker = new mapboxgl.Marker({ color: '#4285F4' })
            .setLngLat([userCoords.lng, userCoords.lat])
            .setPopup(
              new mapboxgl.Popup({ offset: 40, closeButton: false }).setHTML(
                '<div class="map-popup-content"><h4 style="color:#4285F4; margin:0;">You are here</h4></div>'
              )
            )
            .addTo(map);
        }
        renderList(userCoords);
      },
      (err) => {
        if (isAutoLoad) {
          renderList();
          return;
        }
        switch (err.code) {
          case err.PERMISSION_DENIED:
            alert('Location failure: You have rejected the location request.');
            break;
          case err.POSITION_UNAVAILABLE:
            alert('Location failure: Location information is unavailable.');
            break;
          case err.TIMEOUT:
            alert('Location failure: Request timed out.');
            break;
          default:
            alert('Positioning failure: An unknown error has occurred.');
            break;
        }
      },
      { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
    );
  }

  document.getElementById('find-me-btn').onclick = () => executeLocation(false);

  async function handleSearch() {
    const query = document.getElementById('search-input').value.toLowerCase().trim();
    if (!query) return;

    const localMatch = window.dealerStores.find(
      (s) => s.name.toLowerCase() === query || s.name.toLowerCase().includes(query)
    );

    if (localMatch) {
      map.flyTo({ center: [localMatch.lng, localMatch.lat], zoom: 15 });
      renderFilteredList([localMatch]);
      return;
    }

    const endpoint = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${mapboxgl.accessToken}&limit=1&country=us`;

    try {
      const response = await fetch(endpoint);
      const data = await response.json();

      if (data.features && data.features.length > 0) {
        const [lng, lat] = data.features[0].center;
        const searchCoords = { lat, lng };

        map.flyTo({ center: [lng, lat], zoom: 10 });
        renderList(searchCoords);
      } else {
        alert('Location not found. Please try a different search.');
      }
    } catch (error) {
      console.error('Search Error:', error);
      alert('Search failed. Please try again.');
    }
  }

  document.getElementById('search-btn').addEventListener('click', handleSearch);

  const debounceSearch = debounce((e) => {
    const query = e.target.value.toLowerCase().trim();
    if (!query) {
      renderList();
      return;
    }

    const filteredStores = window.dealerStores.filter(
      (store) =>
        store.name.toLowerCase().includes(query) || store.address.toLowerCase().includes(query)
    );
    renderFilteredList(filteredStores);
  }, 500);

  const $input = document.getElementById('search-input');
  $input.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') handleSearch();
  });
  $input.addEventListener('input', (e) => debounceSearch(e));

  // 全部加载完毕后再渲染地图和坐标点
  map.on('load', async () => {
    // 强制等待数据请求接口完成
    // Mapbox 底图加载大约耗时 1s，与数据拉取并行，因此用户几乎无感
    await fetchAllDataPromise;

    map.loadImage(
      'https://cdn.shopify.com/s/files/1/0790/2504/5719/files/dealer-anchor.png?v=1775093179',
      (error, image) => {
        if (error) throw error;
        map.addImage('custom-dealer-marker', image);

        // 此时 window.dealerStores 已经是完整版的数据了，直接注入底层图层！
        map.addSource('dealers-source', {
          type: 'geojson',
          data: convertToGeoJSON(window.dealerStores),
        });

        map.addLayer({
          id: 'dealers-points',
          type: 'symbol',
          source: 'dealers-source',
          layout: {
            'icon-image': 'custom-dealer-marker',
            'icon-anchor': 'bottom',
            'icon-allow-overlap': true,
            'icon-size': 0.4,
            'icon-ignore-placement': true,
          },
        });

        map.on('click', 'dealers-points', (e) => {
          const props = e.features[0].properties;
          const coordinates = e.features[0].geometry.coordinates.slice();

          const store = window.dealerStores.find((s) => s.id === props.id);
          if (store) {
            showStoreDetail(store);
            popup
              .setLngLat(coordinates)
              .setHTML(
                `
              <div class="map-popup-content">
                <h4>${store.name}</h4>
                <p>${store.address}</p>
              </div>
            `
              )
              .addTo(map);
          }
        });

        map.on('mouseenter', 'dealers-points', () => (map.getCanvas().style.cursor = 'pointer'));
        map.on('mouseleave', 'dealers-points', () => (map.getCanvas().style.cursor = ''));
      }
    );

    // 数据和地图全部就绪后，执行定位及第一次完整的侧边栏渲染
    executeLocation(true);
  });
});
